import { Badge, Button, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";

const FeatureModal = ({ data, isOpen, toggle, onConfirm, status, isPub }) => {
  return (
    <Modal isOpen={isOpen} toggle={toggle}>
      <ModalHeader toggle={toggle}>Feature Status</ModalHeader>
      <ModalBody>
        Are you sure you want to {data?.is_feature ? "remove from feature" : "feature"} Dr. {data?.name}
      </ModalBody>
      <ModalFooter>
        <Button color="danger" onClick={toggle}>
          Cancel
        </Button>
        <Button
          color={
            data?.is_feature === "active" || data?.is_feature === true
              ? "warning"
              : "primary" 
          }
          onClick={onConfirm}
        >
          Yes{" "}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default FeatureModal;
